import { Button } from "../../components";
import { DAILY_CARDS, type DailyCardId } from "../../content/dailycards";

export function DailyCard({ id, onDone }: { id: DailyCardId; onDone: () => void }) {
  const card = DAILY_CARDS.find((c) => c.id === id)!;
  return (
    <div class="stage stage-dailycard">
      <p class="stage-kicker">Today's card</p>
      <p class="display stage-hero-sm">{card.name}</p>
      <p class="stage-detail">{card.effect}</p>
      <Button size="lg" onClick={onDone}>
        Begin
      </Button>
    </div>
  );
}
